import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Skeleton from '../shared/TailwindComponents/Skeleton';
import FilterBarWithTabs from '../shared/TailwindComponents/FilterBarWithTabs';
import Header from '../shared/TailwindComponents/Header';
import { useAppDispatch } from '../../store';
import { fetchMatters } from '../../store/actions/Matters/MatterActions';

const FinderBasePage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const cases: any[] = [];
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchUserCases = async () => {
      setIsLoading(true);
      try {
        await dispatch(fetchMatters({ page: 1, page_size: 100 }));
      } catch (err) {
        console.error('Error fetching cases:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserCases();
  }, [dispatch]);

  const filteredCases = cases.filter((caseItem) =>
    caseItem.CaseName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCaseClick = (caseId: string) => {
    history.push(`/finder/${caseId}`);
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <Header actions={[]} />
      <FilterBarWithTabs
        onSearchChange={setSearchQuery}
      />
      <div className="p-6">
        {isLoading ? (
          <Skeleton variant="grid" />
        ) : filteredCases.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCases.map((caseItem) => (
              <div
                key={caseItem.CaseID}
                onClick={() => handleCaseClick(caseItem.CaseID)}
                className="glass rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                <h3 className="text-xl font-semibold">{caseItem.CaseName}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                  {caseItem.description || t('No description')}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600 dark:text-gray-400">
            {t('No cases found. Please create a case to begin.')}
          </p>
        )}
      </div>
    </div>
  );
};

export default FinderBasePage;